export class ExtractedPurchaseOrderHeaderDto {
  supplierId?: string;
  companyId?: string;
  addressId?: string;
  operativeUnitId?: string;
  warehouseId?: string;
  date?: string;
  unmatchedFields: string[];
}
